import TabsHeader from './TabsHeader';

export default TabsHeader;